import { Status } from "@/models/Common/CommonModels"

export type State = {
  status: Status,
}

export const state: State = {
  status: new Status(),
}
